import applicationIcon from "../../../../assets/images/application.svg";
import documentIcon from "../../../../assets/images/document.svg";

type Navigator =
  | {
    type: "navigate";
    label: string;
    icon: string;
    link: string;
  }
  | {
    type: "navigate";
    label: string;
    svg: string;
    link: string;
  };

type DropDown =
  | {
    type: "dropdown";
    label: string;
    icon: string;
    options: Navigator[];
  }
  | {
    type: "dropdown";
    label: string;
    svg: string;
    options: Navigator[];
  };

const ReportsRoute: NavigationRoute = {
  type: "navigate",
  icon: "bar-chart",
  label: "Reports",
  link: "/reports",
};

const RejectedApplicationsRoute: NavigationRoute = {
  type: "navigate",
  icon: "ban",
  label: "Rejected & Revoked",
  link: "/rejected-applications",
};

export type NavigationRoute = Navigator | DropDown;

export const AdminRoutes: NavigationRoute[] = [
  { type: "navigate", icon: "home", label: "Dashboard", link: "/dashboard" },
  {
    type: "dropdown",
    icon: "user",
    label: "Users",
    options: [
      {
        icon: "minus",
        label: "Role Privileges",
        link: "/role-privilege",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Add User",
        link: "/add-user",
        type: "navigate",
      },
    ],
  },
  {
    type: "dropdown",
    icon: "tv",
    label: "General",
    options: [
      {
        icon: "minus",
        label: "Logo",
        link: "/logo",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Banner",
        link: "/banner",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Ticker",
        link: "/ticker",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Footer",
        link: "/footer-page",
        type: "navigate",
      },
    ],
  },
  {
    type: "dropdown",
    svg: applicationIcon,
    label: "Application Setup",
    options: [
      {
        icon: "minus",
        label: "Application ID Generator",
        link: "/system-id-generator",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Registration Fields",
        link: "/registration-fields",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Application Fields",
        link: "/application-fields",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Form Configurations",
        link: "/form-configurations",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Blocked Plot Mapping",
        link: "/blocked-plot-mapping",
        type: "navigate",
      },
    ],
  },
  {
    type: "dropdown",
    svg: documentIcon,
    label: "Document Generator",
    options: [
      {
        icon: "minus",
        label: "Document Config",
        link: "/document-config",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Demand Note",
        link: "/demand-note",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Certificate Condition",
        link: "/certificate-condition",
        type: "navigate",
      },
    ],
  },
  {
    type: "dropdown",
    icon: "cog",
    label: "System Setting",
    options: [
      {
        icon: "minus",
        label: "Override Controller",
        link: "/system-settings",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Plot Shape",
        link: "/plot-shape",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Bank Details",
        link: "/bank-details",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Auto Fill Fields",
        link: "/auto-fill-fields",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Template Config",
        link: "/template-config",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Time Stamp Config",
        link: "/time-stamp-config",
        type: "navigate",
      },
      {
        icon: "minus",
        label: "Demand Note Config",
        link: "/demand-note-config",
        type: "navigate",
      },
    ],
  },
  RejectedApplicationsRoute,
  ReportsRoute,
];

export const Level3Routes: NavigationRoute[] = [
  {
    type: "navigate",
    icon: "home",
    label: "Dashboard",
    link: "/level-three-dashboard",
  },
  {
    type: "navigate",
    icon: "user",
    label: "User Approvals",
    link: "/user-approvals",
  },
  {
    type: "navigate",
    icon: "file-text-o",
    label: "Applications",
    link: "/level-three-applications",
  },
  RejectedApplicationsRoute,
  ReportsRoute,
];

export const Level2Routes: NavigationRoute[] = [
  {
    type: "navigate",
    icon: "home",
    label: "Dashboard",
    link: "/level-2-dashboard",
  },
  {
    type: "navigate",
    icon: "user",
    label: "User Approvals",
    link: "/level-2-user-verifications-list",
  },
  {
    type: "navigate",
    icon: "file-text-o",
    label: "Applications",
    link: "/level-2-applications",
  },
  RejectedApplicationsRoute,
  ReportsRoute,
];

export const Level1Routes: NavigationRoute[] = [
  {
    type: "navigate",
    icon: "home",
    label: "Dashboard",
    link: "/level-1-dashboard",
  },
  {
    type: "navigate",
    icon: "file-text-o",
    label: "Applications",
    link: "/level-1-applications",
  },
  RejectedApplicationsRoute,
  ReportsRoute,
];

export const UserRoutes: NavigationRoute[] = [
  {
    type: "navigate",
    icon: "home",
    label: "Dashboard",
    link: "/user-dashboard",
  },
  {
    type: "navigate",
    icon: "file-text-o",
    label: "Applications",
    link: "/user-applications",
  },
  {
    type: "navigate",
    icon: "money",
    label: "Payment",
    link: "/payment-list",
  },
];
